<section class="color-palette">
  <div class="row">
    <div class="col-12">
      <div class="content-header mb-3">Color Palette</div>
    </div>
  </div>
  <!--App color starts-->
  <div class="row app-color overflow-hidden">
    <div class="color-group col-md-4 col-sm-6 col-12 mb-3">
      <ul class="pl-0">
        <li class="color main-color bg-primary">
          <span class="name light-strong">Primary</span>
          <span class="shade light-strong">500</span>
          <span class="hex light-strong">#975AFF</span>
        </li>
        <li class="color dark bg-primary bg-lighten-4"><span class="shade">100</span><span class="hex">#EFDEFF</span></li>
        <li class="color dark bg-primary bg-lighten-3"><span class="shade">200</span><span class="hex">#DCBDFF</span></li>
        <li class="color dark bg-primary bg-lighten-2"><span class="shade">300</span><span class="hex">#C89CFF</span></li>
        <li class="color bg-primary bg-lighten-1"><span class="shade">400</span><span class="hex">#B583FF</span></li>
        <li class="color bg-primary"><span class="shade">500</span><span class="hex">#975AFF</span></li>
        <li class="color bg-primary bg-darken-1"><span class="shade">600</span><span class="hex">#7441DB</span></li>
        <li class="color bg-primary bg-darken-2"><span class="shade">700</span><span class="hex">#562DB7</span></li>
        <li class="color bg-primary bg-darken-3"><span class="shade">800</span><span class="hex">#3B1C93</span></li>
        <li class="color bg-primary bg-darken-4"><span class="shade">900</span><span class="hex">#28117A</span></li>
      </ul>
    </div>
    <div class="color-group col-md-4 col-sm-6 col-12 mb-3">
      <ul class="pl-0">
        <li class="color main-color bg-success">
          <span class="name light-strong">Success</span>
          <span class="shade light-strong">500</span>
          <span class="hex light-strong">#40C057</span>
        </li>
        <li class="color dark bg-success bg-lighten-4"><span class="shade">100</span><span class="hex">#E0FBDA</span></li>
        <li class="color dark bg-success bg-lighten-3"><span class="shade">200</span><span class="hex">#BDF8B6</span></li>
        <li class="color dark bg-success bg-lighten-2"><span class="shade">300</span><span class="hex">#8EEC8D</span></li>
        <li class="color bg-success bg-lighten-1"><span class="shade">400</span><span class="hex">#6CD975</span></li>
        <li class="color bg-success"><span class="shade">500</span><span class="hex">#40C057</span></li>
        <li class="color bg-success bg-darken-1"><span class="shade">600</span><span class="hex">#2EA54F</span></li>
        <li class="color bg-success bg-darken-2"><span class="shade">700</span><span class="hex">#208A47</span></li>
        <li class="color bg-success bg-darken-3"><span class="shade">800</span><span class="hex">#146F3E</span></li>
        <li class="color bg-success bg-darken-4"><span class="shade">900</span><span class="hex">#0C5C38</span></li>
      </ul>
    </div>
    <div class="color-group col-md-4 col-sm-6 col-12 mb-3">
      <ul class="pl-0">
        <li class="color main-color bg-danger">
          <span class="name light-strong">Danger</span>
          <span class="shade light-strong">500</span>
          <span class="hex light-strong">#F55252</span>
        </li>
        <li class="color dark bg-danger bg-lighten-4"><span class="shade">100</span><span class="hex">#FEE8DC</span></li>
        <li class="color dark bg-danger bg-lighten-3"><span class="shade">200</span><span class="hex">#FECBBA</span></li>
        <li class="color dark bg-danger bg-lighten-2"><span class="shade">300</span><span class="hex">#FCA897</span></li>
        <li class="color bg-danger bg-lighten-1"><span class="shade">400</span><span class="hex">#F9877C</span></li>
        <li class="color bg-danger"><span class="shade">500</span><span class="hex">#F55252</span></li>
        <li class="color bg-danger bg-darken-1"><span class="shade">600</span><span class="hex">#D23B48</span></li>
        <li class="color bg-danger bg-darken-2"><span class="shade">700</span><span class="hex">#B02940</span></li>
        <li class="color bg-danger bg-darken-3"><span class="shade">800</span><span class="hex">#8E1A38</span></li>
        <li class="color bg-danger bg-darken-4"><span class="shade">900</span><span class="hex">#750F33</span></li>
      </ul>
    </div>
    <div class="color-group col-md-4 col-sm-6 col-12 mb-3">
      <ul class="pl-0">
        <li class="color main-color bg-info">
          <span class="name light-strong">Info</span>
          <span class="shade light-strong">500</span>
          <span class="hex light-strong">#2F8BE6</span>
        </li>
        <li class="color dark bg-info bg-lighten-4"><span class="shade">100</span><span class="hex">#D5F1FD</span></li>
        <li class="color dark bg-info bg-lighten-3"><span class="shade">200</span><span class="hex">#ACE0FC</span></li>
        <li class="color dark bg-info bg-lighten-2"><span class="shade">300</span><span class="hex">#81C8F7</span></li>
        <li class="color bg-info bg-lighten-1"><span class="shade">400</span><span class="hex">#60AFF0</span></li>
        <li class="color bg-info"><span class="shade">500</span><span class="hex">#2F8BE6</span></li>
        <li class="color bg-info bg-darken-1"><span class="shade">600</span><span class="hex">#226CC5</span></li>
        <li class="color bg-info bg-darken-2"><span class="shade">700</span><span class="hex">#1750A5</span></li>
        <li class="color bg-info bg-darken-3"><span class="shade">800</span><span class="hex">#0E3885</span></li>
        <li class="color bg-info bg-darken-4"><span class="shade">900</span><span class="hex">#09276E</span></li>
      </ul>
    </div>
    <div class="color-group col-md-4 col-sm-6 col-12 mb-3">
      <ul class="pl-0">
        <li class="color main-color bg-warning">
          <span class="name light-strong">Warning</span>
          <span class="shade light-strong">500</span>
          <span class="hex light-strong">#F77E17</span>
        </li>
        <li class="color dark bg-warning bg-lighten-4"><span class="shade">100</span><span class="hex">#FEEFD0</span></li>
        <li class="color dark bg-warning bg-lighten-3"><span class="shade">200</span><span class="hex">#FEDBA1</span></li>
        <li class="color dark bg-warning bg-lighten-2"><span class="shade">300</span><span class="hex">#FCC173</span></li>
        <li class="color bg-warning bg-lighten-1"><span class="shade">400</span><span class="hex">#FAA750</span></li>
        <li class="color bg-warning"><span class="shade">500</span><span class="hex">#F77E17</span></li>
        <li class="color bg-warning bg-darken-1"><span class="shade">600</span><span class="hex">#D46010</span></li>
        <li class="color bg-warning bg-darken-2"><span class="shade">700</span><span class="hex">#B1460B</span></li>
        <li class="color bg-warning bg-darken-3"><span class="shade">800</span><span class="hex">#8F2F07</span></li>
        <li class="color bg-warning bg-darken-4"><span class="shade">900</span><span class="hex">#762004</span></li>
      </ul>
    </div>
    <div class="color-group col-md-4 col-sm-6 col-12 mb-3">
      <ul class="pl-0">
        <li class="color main-color bg-secondary">
          <span class="name light-strong">Secondary</span>
          <span class="shade light-strong">500</span>
          <span class="hex light-strong">#616D89</span>
        </li>
        <li class="color dark bg-secondary bg-lighten-4"><span class="shade">100</span><span class="hex">#EAF0F9</span></li>
        <li class="color dark bg-secondary bg-lighten-3"><span class="shade">200</span><span class="hex">#D6E1F3</span></li>
        <li class="color dark bg-secondary bg-lighten-2"><span class="shade">300</span><span class="hex">#B5C3DB</span></li>
        <li class="color bg-secondary bg-lighten-1"><span class="shade">400</span><span class="hex">#8F9DB8</span></li>
        <li class="color bg-secondary"><span class="shade">500</span><span class="hex">#616D89</span></li>
        <li class="color bg-secondary bg-darken-1"><span class="shade">600</span><span class="hex">#465375</span></li>
        <li class="color bg-secondary bg-darken-2"><span class="shade">700</span><span class="hex">#303C62</span></li>
        <li class="color bg-secondary bg-darken-3"><span class="shade">800</span><span class="hex">#1E294F</span></li>
        <li class="color bg-secondary bg-darken-4"><span class="shade">900</span><span class="hex">#121A41</span></li>
      </ul>
    </div>
  </div>
  <!--App color Ends-->
</section>

<section class="color-palette" id="other-colors">
  <!-- Color Starts-->
  <div class="row">
      <div class="col-12">
          <div class="content-header mb-3">Palette with More Colors</div>
      </div>
  </div>
  <div class="row">
    <div class="color-group col-md-4 col-sm-6 col-12 mb-3">
      <ul class="pl-0">
        <li class="color main-color bg-grey">
          <span class="name light-strong">Grey</span>
          <span class="shade light-strong">500</span>
          <span class="hex light-strong">#9e9e9e</span>
        </li>
        <li class="color dark bg-grey bg-lighten-4"><span class="shade">100</span><span class="hex">#f5f5f5</span></li>
        <li class="color dark bg-grey bg-lighten-3"><span class="shade">200</span><span class="hex">#eeeeee</span></li>
        <li class="color dark bg-grey bg-lighten-2"><span class="shade">300</span><span class="hex">#e0e0e0</span></li>
        <li class="color bg-grey bg-lighten-1"><span class="shade">400</span><span class="hex">#bdbdbd</span></li>
        <li class="color bg-grey"><span class="shade">500</span><span class="hex">#9e9e9e</span></li>
        <li class="color bg-grey bg-darken-1"><span class="shade">600</span><span class="hex">#757575</span></li>
        <li class="color bg-grey bg-darken-2"><span class="shade">700</span><span class="hex">#616161</span></li>
        <li class="color bg-grey bg-darken-3"><span class="shade">800</span><span class="hex">#424242</span></li>
        <li class="color bg-grey bg-darken-4"><span class="shade">900</span><span class="hex">#212121</span></li>
      </ul>
    </div>

    <div class="color-group col-md-4 col-sm-6 col-12 mb-3">
      <ul class="pl-0">
        <li class="color bg-black"><span class="shade">Black</span><span class="hex">#000000</span></li>
        <li class="color dark bg-white"><span class="shade">White</span><span class="hex">#ffffff</span></li>
      </ul>
    </div>
    <div class="module-end"></div>
  </div>
  <!--Color Pallete Ends-->
</section>
<section class="color-palette" id="gradient-color">
  <!--Gradient Color Starts-->
  <div class="row">
    <div class="col-12">
      <div class="content-header mb-3">Gradient Color Palette</div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4 col-sm-6 col-12 mb-2"><div class="gradient-mint py-4 text-center white font-medium-2">.gradient-mint</div></div>
    <div class="col-md-4 col-sm-6 col-12 mb-2"><div class="gradient-pomegranate py-4 text-center white font-medium-2">.gradient-pomegranate</div></div>
    <div class="col-md-4 col-sm-6 col-12 mb-2"><div class="gradient-blackberry py-4 text-center white font-medium-2">.gradient-blackberry</div></div>
    <div class="col-md-4 col-sm-6 col-12 mb-2"><div class="gradient-flickr py-4 text-center white font-medium-2">.gradient-flickr</div></div>
    <div class="col-md-4 col-sm-6 col-12 mb-2"><div class="gradient-king-yna py-4 text-center white font-medium-2">.gradient-king-yna</div></div>
    <div class="col-md-4 col-sm-6 col-12 mb-2"><div class="gradient-starfall py-4 text-center white font-medium-2">.gradient-starfall</div></div>
    <div class="col-md-4 col-sm-6 col-12 mb-2"><div class="gradient-ibiza-sunset py-4 text-center white font-medium-2">.gradient-ibiza-sunset</div></div>
    <div class="col-md-4 col-sm-6 col-12 mb-2"><div class="gradient-purple-bliss py-4 text-center white font-medium-2">.gradient-purple-bliss</div></div>
    <div class="col-md-4 col-sm-6 col-12 mb-2"><div class="gradient-purple-love py-4 text-center white font-medium-2">.gradient-purple-love</div></div>
    <div class="col-md-4 col-sm-6 col-12"><div class="gradient-man-of-steel py-4 text-center white font-medium-2">.gradient-man-of-steel</div></div>
  </div>
  <!--Gradient Color Ends-->
</section>
